import { useMemo } from 'react';
import { MessagePrimitive, useAssistantState } from '@assistant-ui/react';
import clsx from 'clsx';

import { Icon, Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';

import { useChatContext } from './ChatContext';
import ChatMarkdown from './ChatMarkdown';
import ChatUserMessageAttachmentsContainer from './ChatUserMessageAttachmentsContainer';

import classes from './chat.module.css';

const ChatUserMessage = () => {
  const {
    ui: { chatOpen, chatExpanded },
    messagesData: { messages: rawMessages },
  } = useChatContext();

  const messageId = useAssistantState(state => state.message.id);
  const isSidebarMode = chatOpen && !chatExpanded;

  const impersonation = useMemo(() => {
    const raw = rawMessages.find(msg => msg.id === messageId);
    return (raw as any)?.metadata?.impersonation ?? null;
  }, [rawMessages, messageId]);

  return (
    <MessagePrimitive.Root>
      <div
        className={clsx(
          classes.userMessageContainer,
          isSidebarMode && classes.sidebar,
        )}
      >
        <ChatUserMessageAttachmentsContainer messageId={messageId} />
        <div className={classes.userMessageBubble}>
          <MessagePrimitive.Parts
            components={{
              Text: ChatMarkdown,
            }}
          />
          {impersonation && (
            <Tooltip
              title={`Impersonating: ${impersonation.impersonatedUserFirstName} ${impersonation.impersonatedUserLastName}`}
            >
              <div className={classes.impersonationBadge}>
                <Icon color={colors.brand.blue}>supervised_user_circle</Icon>
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </MessagePrimitive.Root>
  );
};

export default ChatUserMessage;
